import React, { useState, useEffect } from 'react'
import FormCliente from './FormCliente'
import search from '../libs/read-pedido.js'
const  Pedidos = ()=> {
  const [pedidoAtual, setPedidoAtual ] = useState([])
  const [totalAtual, setTotalAtual ] = useState(0)

  const msgCompra = []
  const pedidosEnviar = ()=>{
    let oPedido
    const x = pedidoAtual.map((lanche)=>{
      if (lanche.qtde > 0) {
        msgCompra.push( lanche.descricao + ' ' + lanche.qtde + '. ')
        oPedido = msgCompra.reduce((a, b) => a + b)
      }
    })
    return oPedido
  }
  const atualPedido = pedidosEnviar()
  const url = "https://wa.me/5573999005211?text=" + atualPedido
  useEffect(()=>{
    search.readPedido({setPedidoAtual, setTotalAtual})
  },[])
  const meusPedidos = pedidoAtual.map((lanche, index)=>{
    if (lanche.qtde > 0) {
      return(
        <li key={index} className="preco">
          Lanche: {lanche.descricao}<br />
          Qtde: {lanche.qtde}<br />
          Preço: {new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(lanche.preco)}<br />
          Subtotal: {new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(lanche.subtotal)}
        </li>
      )
    }
    return ''
  })
  const totalUser = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalAtual) +'.'
  const message = totalAtual === 0 ? 'Você ainda não começou seu pedido.' : ''
  const indicarZap =  totalAtual > 0 ? 'Envie seu pedido pelo ZAP. Clicando acima' : ''

  return (
    <div>
    <h1>Pedido Atual</h1>
    <ul id="pedidos-feitos">{meusPedidos}</ul>
    Total nesse pedido: {totalUser} { message }
    <p id="pedidos-total"></p>
    {totalAtual === 0 ? '' : <FormCliente url={url} />}
    <br />
    {indicarZap}
    </div>
  )
}

export default Pedidos
